(function() {
    'use strict';
    angular
        .module('pharmaPortalApp')
        .factory('PortalNotification', PortalNotification);

    PortalNotification.$inject = ['$resource', 'DateUtils'];

    function PortalNotification ($resource, DateUtils) {
        var resourceUrl =  'api/portalNotifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
